export default __webpack_public_path__ + "static/media/White Checkmark Icon.917fc92e.png";